// Dalleo Open Committee & Leadership — titles exactly as provided by the committee.
// Photos, bios, years, and memories are placeholders until members supply them.

export const COMMITTEE = {
  title: "Committee & Leadership",
  intro:
    "Every legendary tournament needs people making questionable decisions behind the scenes. These are the distinguished (and occasionally self-appointed) members responsible for keeping the Dalleo Open traditions alive.",
  members: [
    {
      name: "Christian Villafranco",
      titles: ["Chairman of the Board", "Chief Delegation Officer"],
      years: null,
      bio: null,
      memory: null,
    },
    {
      name: "Zach Doell",
      titles: ["President", "Chief Executive Officer", "Chief Operations Officer", "Vice Chairman of Everything"],
      years: null,
      bio: null,
      memory: null,
    },
    {
      name: "Randy Boner",
      titles: ["Chief Analytics Officer", "Vice President of WOAHs"],
      years: null,
      bio: null,
      memory: null,
    },
    {
      name: "Kaleb Murray",
      titles: ["Director of Second Opinions"],
      years: null,
      bio: null,
      memory: null,
    },
    {
      name: "Nate Breaud",
      titles: ["Chief Instigation Officer"],
      years: null,
      bio: null,
      memory: null,
    },
    {
      name: "Ross Budenski",
      titles: ["Vice President of Strategic Indifference"],
      years: null,
      bio: null,
      memory: null,
    },
    {
      name: "Sean Dimak",
      titles: ["Director of Minimal Involvements"],
      years: null,
      bio: null,
      memory: null,
    },
  ],
};
